// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__LlH+i","tab":"Tabs_tab__4dRNp","tabSelected":"Tabs_tabSelected__xLJ6-","tabIcon":"Tabs_tabIcon__lRyAA"};